/**
 * How Kontroll says a question to the employee was delivered (#275, V7.5.6 T-05): what the manager message
 * channel reported, never «sent» for a stored flag alone.
 */
import type { Clarification } from '@/api/clarifications';
import { T } from '@/i18n';

export const deliveryText = (c: Clarification) =>
  c.delivery === 'push'
    ? T('Sendt som varsel på telefonen og ligger i varslene i Timefly.')
    : c.delivery === 'email'
      ? T('Ligger i varslene i Timefly. Den ansatte fikk en e-post om at det venter en melding.')
      : c.delivery === 'none'
        ? T('Ligger i varslene i Timefly. Ingen varsel på telefon eller e-post ble sendt.')
        : c.delivery === 'failed'
          ? T('Ikke levert. Spørsmålet er lagret, men den ansatte har ikke fått det.')
          : T('Sendes…');
